<template>
  <div class="overall">
    <div class="chart_title chart_title_with_download">
      <span>REITs 个券走势及排名</span>
      <Download :excel_info="excel_info" :downloadImg="false" class="reits-single-download" />
    </div>
    <div class="reits-btn-area">
      <CTimeButtons
        :default="start_date_chart6"
        @CTimeButtons_select_val="fnCTimeButtons_select_val_chart6" />
      <div
        class="reits-date-wrap"
        v-if="start_date_chart6 === '自定义'">
        <DateTimePick
          v-model="date_3"
          :clearable="false"
          @change="dateTimePickChange3" />
      </div>
    </div>
    <div
      v-loading="loading2"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"
      class="echarts_AREA">
      <div
        class="canvasArea3"
        v-for="(node, index) in dCalSingleReitIndex_Ys"
        :key="index"
        :id="node.name"></div>
    </div>
  </div>
</template>

<script>
import { getDateInfo } from '@/utils/util';
import CTimeButtons from '@/components/Basic/CTimeButtonsAddDiy.vue';
import DateTimePick from '@/components/Basic/DateTimePick.vue';
import Download from '@/components/Basic/Download.vue';

export default {
  components: { CTimeButtons, DateTimePick, Download },
  data() {
    const now = new Date();
    const today = new Date();
    today.setFullYear(today.getFullYear() - 1);
    return {
      ROOTFONTFIZE: window.sessionStorage.getItem('ROOTFONTFIZE') || 14,
      excel_info: Object.freeze({
        overviewName: 'REITs个券走势及排名',
        excel_data: [],
        json_fields: {},
      }),
      date_3: [today, now],
      dCalSingleReitIndex_Ys: [],
      start_date_chart6: 'YTD',
      loading2: false,
    };
  },
  watch: {
    '$store.state.theme'() { this.$nextTick(() => this.initChart6()); },
    // CODELIST 异步加载完后重画一次，否则 chart 标题 fallback 到 reitCode
    '$store.state.CODELIST'() { this.$nextTick(() => this.initChart6()); },
  },
  mounted() {
    this.fnGetCalSingleReitIndex();
  },
  beforeDestroy() {
    if (this._resizeObs) { this._resizeObs.disconnect(); this._resizeObs = null; }
    this.dCalSingleReitIndex_Ys.forEach((item) => {
      const dom = document.getElementById(item.name);
      if (dom && this.$echarts) this.$echarts.dispose(dom);
    });
  },
  methods: {
    fnCTimeButtons_select_val_chart6(val) {
      this.start_date_chart6 = val;
      this.fnGetCalSingleReitIndex();
    },
    dateTimePickChange3() {
      this.fnGetCalSingleReitIndex();
    },
    async fnGetCalSingleReitIndex() {
      this.loading2 = true;
      let start_date = this.start_date_chart6;
      start_date = start_date === 'MAX' ? 'max' : start_date;
      const end_date = start_date === '自定义' ? getDateInfo(this.date_3[1]).dateString : '';
      if (start_date === '自定义') {
        start_date = getDateInfo(this.date_3[0]).dateString;
      }
      const { data } = await this.$https.get(
        '/api/cal_single_reit_index?start_date=' + start_date + '&end_date=' + end_date,
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      const _reits = (data.data || [])[0] || {};
      const { tr_date, ..._other } = _reits;
      const fields = Object.keys(_other).reduce((p, c) => {
        p[c] = { callback: (v) => v[c] };
        return p;
      }, {});
      this.excel_info = Object.freeze({
        ...this.excel_info,
        excel_data: data.data || [],
        json_fields: { 日期: 'tr_date', ...fields },
      });

      const dataTmp = data.data || [];
      const arrX = dataTmp.map((n) => n.tr_date);

      // 提取"值"列并按末点数值倒序排列
      let arr2 = [];
      if (dataTmp.length > 0) {
        arr2 = Object.entries(dataTmp[dataTmp.length - 1]);
        arr2.shift();
      }
      arr2.sort((a, b) => b[1] - a[1]);
      arr2 = arr2.map((n) => n[0]);

      // 构建 {name, value: [{key, data}]}
      const FINALLYDATA = arr2.map((node) => ({
        key: node,
        data: arrX.map((date) => {
          const row = dataTmp.find((e) => e.tr_date === date);
          return row ? row[node] : undefined;
        }),
      }));
      const FINALLYDATA_AFTER = arr2.map((node) => ({
        name: node,
        value: FINALLYDATA,
      }));

      this.dCalSingleReitIndex_Ys = FINALLYDATA_AFTER;
      this.chart6_arrX = arrX;
      this.$nextTick(() => this.initChart6());
    },
    initChart6() {
      const FINALLYDATA_AFTER = this.dCalSingleReitIndex_Ys;
      const arrX = this.chart6_arrX || [];
      const COLORSARRAY = this.$store.state.colors;
      const CODELIST = this.$store.state.CODELIST;
      const CODENAME = this.$store.state.CODENAME;
      const theme = this.$store.state.theme;
      const OPTIONDATA = theme === 'dark' ? this.$store.state.OPTIONDATA : this.$store.state.OPTIONDATA_light;

      this.$nextTick(() => {
        FINALLYDATA_AFTER.forEach((item) => {
          const dom = document.getElementById(item.name);
          if (!dom) return;
          // 用 ResizeObserver 等容器有真实宽度再 init，避免压成竖条
          if (!this._resizeObs && window.ResizeObserver) {
            this._resizeObs = new ResizeObserver(() => {
              if (this.dCalSingleReitIndex_Ys.length) this.initChart6();
            });
          }
          this._resizeObs && this._resizeObs.observe(dom);
          const w = dom.clientWidth;
          if (w <= 1) return;
          const chartInstance = this.$echarts.init(dom);
          chartInstance.clear();
          chartInstance.resize();

          const seriesArr = item.value.map((node, idx) => ({
            name: node.key,
            data: node.data,
            type: 'line',
            smooth: false,
            symbol: 'none',
            tooltip: { show: node.key === item.name },
            animationDelay: idx * 60,
          }));

          const colors = item.value.map((node) => {
            if (item.name === node.key) {
              const valobj = CODELIST.find((c) => c.reitCode === node.key);
              const val = valobj ? valobj.reitsTypeL2 : '';
              const obj = COLORSARRAY.find((c) => c.name === val);
              return obj ? obj.value : '#5ae8ed';
            }
            return theme === 'dark' ? 'rgba(118,118,118,0.1)' : 'rgba(196,196,196,0.1)';
          });

          const MAP = CODELIST.find((c) => c.reitCode === item.name);
          const text = MAP ? MAP.reitsName : item.name;

          const option = {
            animation: true,
            animationDuration: 900,
            animationEasing: 'cubicOut',
            tooltip: {
              trigger: 'axis',
              confine: true,
              triggerOn: 'mousemove|click',
              formatter: (val) => {
                let str = '';
                val.forEach((node) => {
                  const v = Number(node.value).toFixed(2);
                  str += `${node.axisValueLabel}<br>${node.marker}${CODENAME[node.seriesName] || node.seriesName}:   ${v}`;
                });
                return str;
              },
            },
            title: {
              text,
              textStyle: { color: OPTIONDATA.title.textStyle.color, fontSize: 12 },
              top: 4,
              left: 6,
            },
            color: colors,
            xAxis: {
              type: 'category',
              data: arrX,
              axisTick: { show: false },
              axisLine: { show: true },
              axisLabel: { show: false },
            },
            yAxis: {
              type: 'value',
              axisLine: { show: true },
              axisTick: { show: false },
              splitLine: { show: false },
              axisLabel: {
                show: true,
                color: OPTIONDATA.xAxis.axisLabel.color,
                fontSize: 10,
              },
            },
            series: seriesArr,
          };

          chartInstance.setOption(option);
        });
        this.loading2 = false;
      });
    },
    reload() { this.fnGetCalSingleReitIndex(); },
  },
};
</script>

<style lang="less" scoped>
.overall {
  background-color: var(--charts_bgc);
  height: auto;
  padding-top: calc(var(--ROOTFONTFIZE) * (15 / 144));
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-right: calc(var(--ROOTFONTFIZE) * (16 / 144));
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-left: 0;
  box-sizing: border-box;
}

.chart_title {
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-weight: 700;
  border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
  padding-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
  height: calc(var(--ROOTFONTFIZE) * (28 / 144));
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (12 / 144));
}
.chart_title_with_download {
  padding-right: calc(var(--ROOTFONTFIZE) * (8 / 144));
}
.reits-single-download {
  margin-left: auto;
}

.reits-btn-area {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: calc(var(--ROOTFONTFIZE) * (27 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
  position: relative;
}
.reits-date-wrap {
  margin-left: calc(var(--ROOTFONTFIZE) * (10 / 144));
}

.echarts_AREA {
  padding-left: calc(var(--ROOTFONTFIZE) * (10 / 144));
  padding-right: calc(var(--ROOTFONTFIZE) * (10 / 144));
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-content: flex-start;
  width: 100%;
  box-sizing: border-box;
}

.canvasArea3 {
  // 一行 6 个：每个占 (总宽 - 5*gap) / 6
  flex: 0 0 calc((100% - calc(var(--ROOTFONTFIZE) * (60 / 144))) / 6);
  width: calc((100% - calc(var(--ROOTFONTFIZE) * (60 / 144))) / 6);
  height: calc(var(--ROOTFONTFIZE) * (200 / 144));
  min-height: 180px;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-right: calc(var(--ROOTFONTFIZE) * (10 / 144));
  border: none;
  box-sizing: border-box;
}

.HEIGHTAUTO {
  height: auto;
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
}
</style>